"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TIMEOUT = exports.PENDING = exports.FAILURE = exports.SUCCESS = void 0;
var SUCCESS = 'SUCCESS';
exports.SUCCESS = SUCCESS;
var FAILURE = 'FAILURE';
exports.FAILURE = FAILURE;
var PENDING = 'PENDING';
exports.PENDING = PENDING;
var TIMEOUT = 'TIMEOUT';
exports.TIMEOUT = TIMEOUT;